import React from "react";
import { FaAward, FaTools, FaTruck, FaUserShield } from "react-icons/fa";
import "../pages/Home.css";

const data = [
  {
    id: 1,
    title: "Free Pickup",
    icon: <FaTruck />,
    color: "#60a5fa",
    desc: "Doorstep mobile repair service in Bangalore at no extra cost."
  },
  {
    id: 2,
    title: "Warranty",
    icon: <FaAward />,
    color: "#3b82f6",
    desc: "Up to 12 months warranty on all mobile repair services in Bangalore."
  },
  {
    id: 3,
    title: "Genuine Parts",
    icon: <FaTools />,
    color: "#2563eb",
    desc: "We use 100% original parts for mobile repair in Bangalore."
  },
  {
    id: 4,
    title: "Certified Techs",
    icon: <FaUserShield />,
    color: "#1d4ed8",
    desc: "Certified technicians providing trusted mobile repair service in Bangalore."
  },
];

const WhyChooseUs = () => {
  return (
    <section className="home-why-section">
      <div className="home-why-container">

        {/* HEADER */}
        <div className="home-why-header">
          <span className="home-why-subtitle">Premium Service</span>

          {/* ✅ SEO HEADING */}
          <h2 className="home-why-title">
            Why Choose Our <span className="home-why-highlight">Mobile Repair Service in Bangalore</span>
          </h2>

          {/* ✅ SEO DESCRIPTION */}
          <p>
            We provide fast, reliable and affordable mobile repair service in Bangalore
            with doorstep pickup, certified technicians and warranty support.
          </p>
        </div>

        {/* GRID */}
        <div className="home-why-grid">
          {data.map((item) => (
            <div
              key={item.id}
              className="home-why-card"
              style={{ "--accent": item.color }}
            >
              <div className="home-why-icon-box">{item.icon}</div>

              <div className="home-why-card-content">
                <h3>{item.title} Service</h3>
                <p>{item.desc}</p>
              </div>

              <div className="home-card-border-gradient"></div>
            </div>
          ))}
        </div>

        {/* ✅ HIDDEN SEO */}
        <div style={{ display: "none" }}>
          mobile repair Bangalore, phone repair Bangalore,
          doorstep mobile repair Bangalore, certified mobile technicians Bangalore,
          best mobile repair service Bangalore
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;